import React, { useEffect, useState } from "react";

import estilo from "./styles/Tarjeta.module.css";
import gris from "../img/gris.png";

function Tarjeta({ ultimos }) {
  const [load, setLoad] = useState(false);

  useEffect(() => {
    setLoad(true);
  }, []);

  const reducirPalabras = (e, num) => {
    const palabras = e.split(" ");
    if (palabras.length <= num) {
      return e;
    } else {
      return palabras.slice(0, num).join(" ") + "...";
    }
  };
  return (
    <div className={estilo.contenido}>
      <div className={estilo.portada}>
        {load ? (
          <img src={ultimos.portada} alt={ultimos.nombre} />
        ) : (
          <img src={gris} alt="imagen de carga" />
        )}
      </div>

      <p>{reducirPalabras(ultimos.nombre, 6)}</p>

      <div className={estilo.numero}>
        <p>{ultimos.capitulos[0].numero}</p>
      </div>
    </div>
  );
}

export default Tarjeta;
